import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore, usePageStore } from '@/store';
import util from '@/common/util';
import PSwp from '../../components/pswp.vue';
import breadCrumb from './breadCrumb.vue';
// import VideoPlayer from './video-player.vue';
import SharePopper from './share-popper.vue';
import global from '@/common/global';
import API from './api.js';
import { INTERCEPT_MLS } from '@/common/customize';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
import { adNewQuestions } from '@/components/adQuestionsPop/index.js';
import { buildUrl } from '@/router/index.js';
function getMatterPort(links = [], type = '3d') {
    let reg = /matterport\.(com|cn)\/show/;
    let matterPortLink = links.find(l => reg.test(l));
    if (!matterPortLink) {
        return false; 
    }
    return {
        type,
        url: matterPortLink,
        preview:
            '//cdn.chime.me/image/fs/sitebuild/site-cms/listing-detail/3d.jpeg'
    };
}

export default {
    i18next: {
        ns: 'md-detail-info'
    },
    inject: [
        'click3D',
        'onFavoriteClick',
        'sharePop',
        'getMediaPopIns',
        'getGalleryPopIns',
        'schedulePop'
    ],
    components: {
        Swiper,
        Slide: SwiperSlide,
        PSwp /*, VideoPlayer*/,
        SharePopper,
        breadCrumb
    },
    props: {
        showPreviousNext: {
            type: Boolean,
            default: true
        },
        listingDetail: {
            type: Object,
            required: true
        },
        scheduleInfo: {
            type: Object,
            default: () => ({})
        },
        apptTitle: {
            type: String,
            default: ''
        },
        apptSubTitle: {
            type: String,
            default: ''
        },
        apptSubmitText: {
            type: String,
            default: ''
        },
        apptQuestionMsg: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            swiper: null,
            defaultImg:
                '//fs01.chime.me/image/fs/sitebuild/2021224/20/original_ddff9285-b8a4-4fd5-840f-0233eb9cc979.png',
            allImages: [],
            swiperOption: {},
            swiperReady: false,
            canRight: false,
            canLeft: false,
            curPage: 0,
            lazyload: true,
            photoswipeOption: {},
            slidesPerGroup: 1,
            space: 0,
            mobileStep: 1,
            pcStep: 1,
            speed: 300,
            video: null,
            imageStartIndex: 0,
            theme: '',
            loop: false,
            fixedBannerStyle: null,
            enableNavigation: true
        };
    },
    created() {
        this.init();
    },
    mounted() {
        this.setOption && this.setOption();
        global.scroll(this.onScroll);
        this.fixedBannerStyle = {
            paddingRight: `${
                window.innerWidth - this.$refs.banner.offsetWidth
            }px`
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            "page": store => store.page,
            "pageKey": store => store.page.pageKey
        }),
        ...rootMapState(useUserStore, {
            "user": store => store.user,
        }),
        ...mapState({
            "prevAndNext": "prevAndNext",
            "hasFavor": "hasFavor",
            "shares": "shares"
        }),
        notApp() {
            return !this.platform.inApp;
        },
        showUpdateAndDay({ info }) {
            //CHIME-21882
            return !INTERCEPT_MLS.hiddenUpdateTime.includes(
                util.getValueByPath(info, 'mlsOrg.id', 0)
            );
        },
        info() {
            return this.listingDetail.info || {};
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        
        
        wordPressSSR({ page }) {
            return page.wordPressSSR;
        },
        inPopDetailPage() {
            return util.inPopDetailPage;
        },
        slidesPerView() {
            return 1;
        },
        imgAlt() {
            return (
                this.info &&
                [this.info.cityAddress, this.info.streetAddress]
                    .filter(_ => _)
                    .join()
            );
        },
        videoImgAlt() {
            return [this.imgAlt, this.$t('md-detail-info.videoTour')].join();
        },
        isSoldHouse() {
            return this.info.listingStatus === 'Sold';
        },
        options({ enableNavigation, slidesPerGroup, slidesPerView }) {
            let options = {
                speed: this.speed,
                spaceBetween: this.space,
                slidesPerGroup: slidesPerGroup,
                slidesPerView: slidesPerView,
                loop: this.loop
            };
            if (enableNavigation) {
                options.navigation = {
                    prevEl: '.swiper-button-prev',
                    nextEl: '.swiper-button-next',
                    disabledClass: 'swiper-button-disabled'
                };
            }
            options = fixSwiperOptions(options);
            return options;
        }
    },
    methods: {
        init() {
            const info = this.info;
            let listingPictures = !info.listingPictures
                ? []
                : info.listingPictures.split('|').filter(item => !!item);

            let { link, chimeVideoLink } = info;
            let virtualLinks = link ? link.split(' ') : [],
                videoLinks = chimeVideoLink ? chimeVideoLink.split(' ') : [];
            let matterport = getMatterPort([...virtualLinks, ...videoLinks]);
            if (listingPictures.length === 0) {
                listingPictures.push(
                    '//fs01.chime.me/image/fs/sitebuild/2021224/20/original_ddff9285-b8a4-4fd5-840f-0233eb9cc979.png'
                );
            }
            const firstImg = listingPictures[0];
            if (this.theme === 'layout1') {
                if (virtualLinks.length > 0) {
                    listingPictures.splice(0, 0, {
                        type: '3d',
                        url: virtualLinks[0],
                        preview: firstImg
                    })
                }
                if (videoLinks.length > 0) {
                    listingPictures.splice(0, 0, {
                        type: 'video',
                        url: videoLinks[0],
                        preview: firstImg
                    })
                }
            } else {
                if (matterport) {
                    //  all terminal matterport inserted into the second
                    listingPictures.splice(1, 0, matterport);
                    this.imageStartIndex = 1;
                }
            }

            this.allImages = listingPictures;
            if (!this.isMobileSize && this.allImages.length > this.pcStep) {
                this.canRight = true;
            }
        },
        onSwiperReady(swiper) {
            this.photoswipeOption.mySwiper = swiper;
            this.photoswipeOption.images = this.allImages;
            this.photoswipeOption.elems =
                this.$el.querySelectorAll('.swiper-img img');
            if (this.isMobileSize) {
                this.photoswipeOption.swiperNum = this.mobileStep;
            } else {
                this.photoswipeOption.swiperNum = this.pcStep;
            }
        },
        async touched(index, $event, item = {}) {
            // if (!this.isMobileSize) {
            //     this.lazyload = false;
            //     if (item && item.type == '3d') {
            //         this.click3D(item.url, this.theme);
            //         return;
            //     }
            //     this.$refs.pswp.openPhotoSwipe(index, $event.target);
            // } else {
            // }
            //  mobile display mediaPop

            const { url, type } = item;
            // const url = `https://www.dropbox.com/s/2lza92tb05edq6p/27th%20HPP%20Final.mov?dl=0`
            if (url && type && type !== 'img') {
                const res = await API.getCanXFrame.call(this, url);
                if (!res?.data?.canXFrame) {
                    window.open(url, '_blank');
                    return;
                }
            }
            if (this.isMobileSize) {
                if (this.theme === 'layout1') {
                    if (type === 'video') {
                        this.getMediaPopIns()?._openVideoPop();
                    } else if (type === '3d') {
                        this.getMediaPopIns()?._openVirtualTourPop();
                    } else {
                        this.getMediaPopIns()?._openMediaPop(index, $event, item);
                    }
                } else {
                    if (item?.type === '3d') {
                        index--;
                    }
                    const realIndex = index <= 0 ? 0 : index;
                    this.getMediaPopIns()?._openMediaPop(realIndex);
                } 
            } else {
                if (this.theme !== 'layout1') {
                    this.getGalleryPopIns()?._openGalleryPop(index, $event, item);
                } else {
                    if (type === 'video') {
                        this.getGalleryPopIns()?._openVideoPop();
                    } else if (type === '3d') {
                        this.getGalleryPopIns()?._openVirtualTourPop();
                    } else {
                        this.getGalleryPopIns()?._openGalleryPop(index, $event, item);
                    }
                }
            }
        },
        handleSlideChange(swiper) {
            this.curPage = swiper.activeIndex + 1;
            if (
                swiper.activeIndex == 4
            ) {
                adNewQuestions.openAdQuestionPop({ describeToQuestion: true });
            }
        },
        onImgLoad(index, $event) {
            if (this.video && this.video.videoLink) {
                this.$refs.pswp.updateImgSize(
                    index - 1,
                    $event.width,
                    $event.height
                );
            } else {
                this.$refs.pswp.updateImgSize(
                    index,
                    $event.width,
                    $event.height
                );
            }
        },
        putAway() {
            if (window.parent !== window && window.parent.__curDetailPop) {
                window.parent.__curDetailPop.hide();
            } else {
                let url =
                    this.pageKey === 'listing-detail'
                        ? `${buildUrl({ name: 'listing' })}${this.pageLocation.search}`
                        : this.pageKey === 'listing-detail-sold'
                            ? `${buildUrl({ name: 'sold-listing' })}${this.pageLocation.search}`
                            : '/';
                window.siteAppVm.$EventBus.$emit('change-url', url);
            }
        },
        onFavClick() {
            this.onFavoriteClick();
        },
        onScroll() {
            //  Specifically implemented in each set of styles
        }
    },
    unmounted() {
        global.scroll(this.onScroll, true);
    }
};
